<h2 mat-dialog-title class="sk-dialog-title"><mat-icon>table_view</mat-icon> Excel exportieren</h2>

<mat-dialog-content class="dialog-content">
  <p class="sk-muted intro" *ngIf="data.auftragTitel">
    Regie-Abrechnung „{{ data.auftragTitel }}“ – bitte den Umfang des Exports wählen.
  </p>

  <!-- Hauptauswahl -->
  <mat-radio-group class="auswahl" [(ngModel)]="modus" (change)="auswahlGeaendert()" [disabled]="exportLaeuft"
    aria-label="Exportumfang">
    <mat-radio-button value="gesamt" class="auswahl-option">
      <span class="option-text">
        <strong>Gesamtübersicht</strong>
        <span class="sk-muted">Alle Einsätze gemeinsam in einem Übersichtsblatt mit Summen.</span>
      </span>
    </mat-radio-button>

    <!-- Unterauswahl Gesamtübersicht -->
    <div class="unterauswahl" *ngIf="modus === 'gesamt'">
      <mat-radio-group class="auswahl" [(ngModel)]="gesamtModus" (change)="auswahlGeaendert()" [disabled]="exportLaeuft"
        aria-label="Umfang der Gesamtübersicht">
        <mat-radio-button value="nur" class="auswahl-option">
          <span class="option-text">
            <strong>Nur Gesamtübersicht</strong>
            <span class="sk-muted">Eine Excel-Datei mit genau einem Tabellenblatt „Übersicht“.</span>
          </span>
        </mat-radio-button>

        <mat-radio-button value="mitEinsaetzen" class="auswahl-option">
          <span class="option-text">
            <strong>Gesamtübersicht und einzelne Einsätze</strong>
            <span class="sk-muted">„Übersicht“ und danach ein Regieblatt je Einsatz (RA0001, RA0002, …).</span>
          </span>
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <mat-radio-button value="einsaetze" class="auswahl-option">
      <span class="option-text">
        <strong>Nach Einsätzen</strong>
        <span class="sk-muted">Ein Regieblatt je Einsatz mit Zeitraum, Stunden, Material und Summen.</span>
      </span>
    </mat-radio-button>
  </mat-radio-group>



  <!-- Unterauswahl Nach Einsätzen -->
  <div class="unterauswahl" *ngIf="modus === 'einsaetze'">
    <mat-radio-group class="auswahl" [(ngModel)]="einsatzModus" (change)="auswahlGeaendert()"
      [disabled]="exportLaeuft || einsaetze.length === 0" aria-label="Einsatzauswahl">
      <mat-radio-button value="einzeln" class="auswahl-option">
        <span class="option-text">
          <strong>Einen bestimmten Einsatz exportieren</strong>
          <span class="sk-muted">Eine Excel-Datei mit genau einem Tabellenblatt.</span>
        </span>
      </mat-radio-button>

      <mat-radio-button value="alle" class="auswahl-option">
        <span class="option-text">
          <strong>Alle Einsätze einzeln exportieren</strong>
          <span class="sk-muted">Eine Excel-Datei, ein Tabellenblatt je Einsatz (RA0001, RA0002, …).</span>
        </span>
      </mat-radio-button>
    </mat-radio-group>

    <div class="sk-loading einsaetze-laden" *ngIf="einsaetzeLaden">
      <mat-spinner diameter="26"></mat-spinner>
      <span class="sk-muted">Einsätze werden geladen …</span>
    </div>

    <p class="hinweis fehler" *ngIf="einsaetzeFehler">
      <mat-icon>error_outline</mat-icon> {{ einsaetzeFehler }}
    </p>

    <p class="hinweis" *ngIf="keineEinsaetze">
      <mat-icon>info_outline</mat-icon>
      Für dieses Projekt sind keine Einsätze mit abgerechneten Stunden oder Material vorhanden.
    </p>

    <mat-form-field appearance="outline" class="einsatz-feld"
      *ngIf="einsatzModus === 'einzeln' && einsaetze.length > 0">
      <mat-label>Einsatz</mat-label>
      <mat-select [(ngModel)]="einsatzId" (selectionChange)="auswahlGeaendert()" [disabled]="exportLaeuft"
        placeholder="Einsatz wählen">
        <mat-option *ngFor="let e of einsaetze" [value]="e.einsatzId">
          <span class="einsatz-option">
            <strong>{{ e.nummer }}</strong>
            <span class="einsatz-titel">{{ e.titel }}</span>
            <span class="sk-muted">{{ zeitraum(e) }}</span>
          </span>
        </mat-option>
      </mat-select>
      <mat-hint *ngIf="einsaetze.length > 1">{{ einsaetze.length }} Einsätze vorhanden</mat-hint>
    </mat-form-field>
  </div>

  <p class="hinweis fehler" *ngIf="fehler">
    <mat-icon>error_outline</mat-icon> {{ fehler }}
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="abbrechen()" [disabled]="exportLaeuft">Abbrechen</button>
  <button mat-raised-button color="primary" (click)="exportieren()" [disabled]="!kannExportieren">
    <mat-spinner *ngIf="exportLaeuft" diameter="18"></mat-spinner>
    <mat-icon *ngIf="!exportLaeuft">download</mat-icon>
    {{ exportLaeuft ? 'Wird erstellt …' : 'Exportieren' }}
  </button>
</mat-dialog-actions>